import { toast } from "react-toastify";

interface CustomToastProps {
  message?: string;
  title: string;
  customId: "loading" | "error" | "invalid" | "success";
  showButton?: boolean;
  buttonText?: string;
  onButtonClick?: () => void;
}

const CustomToast = ({ message, title, customId, showButton = false, buttonText = "Check Requests", onButtonClick }: CustomToastProps) => (
  <div className="tw-text-label-md tw-flex tw-flex-col tw-gap-1 tw-relative">
    <div className="tw-text-white tw-flex tw-items-center tw-gap-1 -tw-ml-1">
      {customId === "loading" ? (
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#f3e781">
            <path d="M522-80v-82q34-5 66.5-18t61.5-34l56 58q-42 32-88 51.5T522-80Zm-80 0Q304-98 213-199.5T122-438q0-75 28.5-140.5t77-114q48.5-48.5 114-77T482-798h6l-62-62 56-58 160 160-160 160-56-56 64-64h-8q-117 0-198.5 81.5T202-438q0 104 68 182.5T442-162v82Zm322-134-58-56q21-29 34-61.5t18-66.5h82q-5 50-24.5 96T764-214Zm76-264h-82q-5-34-18-66.5T706-606l58-56q32 39 51 86t25 98Z" />
          </svg>
        </div>
      ) : customId === "error" ? (
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e24a1a">
            <path d="m40-120 440-760 440 760H40Zm138-80h604L480-720 178-200Zm302-40q17 0 28.5-11.5T520-280q0-17-11.5-28.5T480-320q-17 0-28.5 11.5T440-280q0 17 11.5 28.5T480-240Zm-40-120h80v-200h-80v200Zm40-100Z" />
          </svg>
        </div>
      ) : customId === "invalid" ? (
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#f04438">
            <path d="m336-280 144-144 144 144 56-56-144-144 144-144-56-56-144 144-144-144-56 56 144 144-144 144 56 56ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
          </svg>
        </div>
      ) : (
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#66e7a9">
            <path d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
          </svg>
        </div>
      )}

      <div className="tw-font-medium tw-pl-1">{title}</div>
    </div>

    {message && <div className="tw-text-gray-300 tw-ml-7">{message}</div>}

    {showButton && (
      <div className="tw-ml-[28px] tw-mt-2">
        <button onClick={onButtonClick} className="tw-bg-purple-500 tw-text-white tw-px-4 tw-py-2 tw-rounded-lg tw-text-label-md tw-font-medium hover:tw-bg-purple-700">
          {buttonText}
        </button>
      </div>
    )}

    <div
      className="tw-text-heading-xs tw-text-black tw-bg-black tw-rounded-full tw-flex tw-items-center tw-justify-center tw-absolute -tw-top-6 -tw-right-5 tw-p-0.5 tw-leading-none tw-cursor-pointer"
      onClick={() => toast.dismiss()}>
      <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="#FFFFFF">
        <path d="m291-240-51-51 189-189-189-189 51-51 189 189 189-189 51 51-189 189 189 189-51 51-189-189-189 189Z" />
      </svg>
    </div>
  </div>
);

export default CustomToast;
